module.exports = __webpack_public_path__ + "static/media/animalShelter.e44d4154.png";